// removed by extract-text-webpack-plugin
module.exports = {"header":"c-SectionHeader__header","title":"c-SectionHeader__title","accent":"c-SectionHeader__accent","light":"c-SectionHeader__light"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/SectionHeader/SectionHeader.scss
// module id = 458
// module chunks = 0